import styled from 'styled-components'
import Icon from './Icon'

const ShareIcon = styled(Icon).attrs({
  type: 'share',
})``

export default ShareIcon
